import request from '../utils/RequestUtil'
//desafio service
function getChallenge(id){
    return request({
        url: '/desafio',
        data: {
            id: id
        },
        method: 'POST'
    });
}

function validatePassword(password){
    return request({
        url: '/desafio/password',
        data: {
            password
        },
        method: 'PUT'
    });
}

function getSMSchallenge(){
    return request({
        url: '/desafio/sms',
        method: 'POST'
    });
}

function validateSMS(codigo){
    return request({
        url:'/desafio/sms',
        data: {
            codigo
        },
        method: 'PUT'
    });
}

export { getChallenge, validatePassword, getSMSchallenge, validateSMS };